import undoable, { excludeAction } from 'redux-undo';

import { UsableObjectConfig } from 'dashboard/lib/workflows';
import { Workflow, WorkflowConfigError } from 'dashboard/models/workflow';
import { WorkflowDeployment } from 'dashboard/models/workflow-deployment';
import {
  WorkflowStep,
  WorkflowStepInput,
  WorkflowVersion,
} from 'dashboard/models/workflow-version';
import { WorkflowActions, WorkflowActionType } from 'dashboard/redux/actions/workflow';

export type WorkflowState = {
  workflow: Workflow;
  workflowVersion: WorkflowVersion;
  publishedWorkflowVersion: WorkflowVersion;
  workflowDeployment: WorkflowDeployment | null;
  inputStep: WorkflowStepInput;
  workflowVersionErrors: WorkflowConfigError[];
  stepsConfig: WorkflowStep[];
  stepContexts: Record<string, UsableObjectConfig[]>;
};

export const initialState: WorkflowState = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  workflow: undefined,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  workflowVersion: undefined,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  publishedWorkflowVersion: undefined,
  workflowDeployment: null,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  inputStep: undefined,
  workflowVersionErrors: [],
  stepsConfig: [],
  stepContexts: {},
};

export const WorkflowsReducer = (state: WorkflowState = initialState, action: WorkflowActions) => {
  switch (action.type) {
    case WorkflowActionType.SetWorkflow: {
      return {
        ...state,
        workflow: action.payload.workflow,
      };
    }
    case WorkflowActionType.SetWorkflowVersion: {
      return {
        ...state,
        workflowVersion: action.payload.workflowVersion,
        // TODO @jkim - update everywhere to pull steps config from here instead of from workflowVersion (PLF-4020)
        stepsConfig: action.payload.workflowVersion.attributes['steps-config'],
      };
    }
    case WorkflowActionType.SetPublishedWorkflowVersion: {
      return {
        ...state,
        publishedWorkflowVersion: action.payload.workflowVersion,
      };
    }
    case WorkflowActionType.SetWorkflowDeployment: {
      return {
        ...state,
        workflowDeployment: action.payload.workflowDeployment,
      };
    }
    case WorkflowActionType.SetInputStep: {
      return {
        ...state,
        inputStep: action.payload.inputStep,
      };
    }
    case WorkflowActionType.SetWorkflowVersionErrors: {
      return {
        ...state,
        workflowVersionErrors: action.payload.errors,
      };
    }
    case WorkflowActionType.SetStepsConfig: {
      return {
        ...state,
        stepsConfig: action.payload.stepsConfig,
      };
    }
    case WorkflowActionType.SetStepContexts: {
      return {
        ...state,
        stepContexts: {
          ...state.stepContexts,
          ...action.payload.stepContexts,
        },
      };
    }
    default:
      return state;
  }
};

export default undoable(WorkflowsReducer, {
  undoType: WorkflowActionType.Undo,
  redoType: WorkflowActionType.Redo,
  clearHistoryType: WorkflowActionType.ClearHistory,
  limit: 15,
  filter: excludeAction([
    WorkflowActionType.SetStepContexts,
    WorkflowActionType.SetWorkflowVersionErrors,
    WorkflowActionType.SetWorkflow,
  ]),
});
